import { useState, useEffect, useRef } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Numbers from "../Components/Numbers";
import QSleeveImage from "../Images/videothumbnail.jpg";
import Banner from "../Components/Banner";
import { homepagebox } from "../Data/Aboutus";
import { HomeBoxHover } from "../Components/BoxHover";
import global from "../../src/Images/globe.png";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import VideoComponent from "../Components/VideoComponent";
import ScamAlertPopup from "../Components/ScamAlertPopup";
import TitleContent from "../Components/TitleContent";
import ServicesBox from "../Components/ServicesBox";
import { KeyFeatures, KeyFeaturesCard } from "../Components/KeyFeatures";
export default function Home() {
  // const backgroundImageBig = generateSvgDataUrl("#060606", 70, 70);
  // const backgroundImageSmall = generateSvgDataUrl("#060606", 50, 50);
  // const [backgroundImage, setBackgroundImage] = useState(backgroundImageSmall);
  const VideoRef = useRef(null);
  const [toggle, setToggle] = useState(false);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();
    window.addEventListener("resize", updateBackgroundImage);
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToVideo = () => {
    if (!VideoRef.current) return;

    VideoRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start", // important
    });
  };

  // useEffect(() => {
  //   const updateBackgroundImage = () => {
  //     const screenWidth = window.innerWidth;

  //     if (screenWidth >= 1536) {
  //       setBackgroundImage(backgroundImageBig);
  //     } else {
  //       setBackgroundImage(backgroundImageSmall);
  //     }
  //   };

  //   updateBackgroundImage();

  // }, []);
  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full   width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={1} />

        <div className="w-full bg-primary7 ">
          <Banner
            mainBanner={
              <div className="relative w-full h-[60vh] lg:h-[95vh]">
                {/* Background Image */}
                <img
                  className="absolute inset-0 w-full h-full object-cover mix-blend-exclusion saturate-30 brightness-[0.7]"
                  src={require("../../src/Images/Homepage.jpeg")}
                  alt="banner"
                />

                {/* Content Overlay */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                  <p
                    className="hidden md:block md:text-6xl font-RobotoBold font-extrabold text-white"
                    // style={{
                    //   WebkitTextStroke: "3px white",
                    //   color: "transparent",
                    // }}
                  >
                    We Are Building A
                  </p>

                  <p
                    className="block md:hidden text-[2.5rem] font-RobotoBold font-extrabold text-white"
                    // style={{
                    //   WebkitTextStroke: "2px white",
                    //   color: "transparent",
                    // }}
                  >
                    We Are Building A
                  </p>

                  <p
                    className="mt-2 hidden md:block md:text-6xl font-RobotoBold wordGradient"
                    // style={{
                    //   WebkitTextStroke: "3px #1B99D4",
                    //   color: "transparent",
                    // }}
                  >
                    Quantum Future
                  </p>

                  <p
                    className="mt-[0.3rem] block md:hidden text-[2.5rem] font-RobotoBold wordGradient"
                    // style={{
                    //   WebkitTextStroke: "2px #1B99D4",
                    //   color: "transparent",
                    // }}
                  >
                    Quantum Future
                  </p>

                  <p className="md:w-2/3 md:text-xl w-full text-sm font-RobotoRegular my-6 text-white">
                    We Engineer Solutions To Complex Problems Using Quantum
                    Principles
                  </p>
                </div>
              </div>
            }
          />
          {/* <MainHerosection
            title1="Welcome To"
            title2="Qulabs"
            content="Leading the way in Quantum & AI Solutions"
            MainHerosection={scrollToVideo}
          /> */}
          <Numbers />
          <TitleContent title="Services We Can Help You With" content="" />

          <div className="w-full h-[22rem] relative flex items-center justify-center px-5 py-10 gap-8">
            <ServicesBox />
          </div>

          <div className="w-full flex flex-col width  py-10  items-center justify-center">
            <div className="relative w-full flex flex-col gap-1 items-center justify-center h-[25rem] overflow-hidden">
              {/* Background Image Layer */}
              <div
                className="absolute inset-0 bg-cover bg-center opacity-40"
                style={{
                  backgroundImage: `url(${require("../../src/Images/Ourstory.jpg")})`,
                }}
              ></div>

              {/* Content Layer */}
              <div className="relative z-10 w-full flex flex-col items-center justify-center">
                {/* Heading */}
                <TitleContent title="Our Story" content="" />

                {/* Description */}
                <div className="w-[95%] md:w-[70%] 2xl:w-[50%]">
                  <p className="font-RobotoRegular text-xs md:text-sm  text-white ">
                    Started in 2018, we are among the first global companies in
                    Quantum Communications & Quantum Artificial Intelligence
                    with our prime focus on solutions development in
                    communication security, finance, and post-quantum cyber
                    security.
                  </p>

                  {/* List */}
                  <KeyFeatures
                    features={[
                      "Deliver reliable, high quality, cost-effective, efficient, scalable, and secure quantum communication solutions to a global marketplace",
                      "Provide the world it's most secure Quantum Internet & create completely secure communication at immense speed and security",
                      "Develop scalable products and services in quantum computing, controlled by a holistic software stack",
                      "Prepare next generation skilled manpower and boost translational research in Quantum Hardware and Software",
                      "Harvest quantum technology for strategic and economic development",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="w-full bg-primary7  width flex flex-col items-center justify-center md:px-10 2xl:px-20 gap-6 pb-10 relative">
          <div className="w-full h-auto lg:h-[40rem] p-3 width grid grid-cols-1 lg:grid-cols-2 justify-items-center   items-center  ">
            <div className="w-full md:w-[90%] h-full flex flex-col justify-center items-center   p-3">
              <div className="w-full  flex flex-col items-center justify-center gap-1">
                <div className="w-full  text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3">
                  Explore Quantum Revolution at
                </div>{" "}
                <div className="w-full  text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold wordGradient leading-tight px-3 mb-3">
                  {" "}
                  Qulabs
                </div>
              </div>
              <div className="w-full text-white text-center md:text-left font-RobotoRegular text-xs md:text-sm px-3 ">
                Qulabs is unique in its approach to Quantum
                Technology powered by Intelligence. We are the forefront of the
                quantum development in hardware and software. We started our
                work in late 2018 with the establishment of Qulabs, a dedicated
                Quantum lab under Qulabs with a vision to build and
                commercialise technologies necessary for long-distance
                quantum-secure communication in India.
              </div>
              <div className="w-full text-white text-center md:text-left font-RobotoRegular text-xs md:text-sm px-3 ">
                We thrive on our motto ‘collaboration and not competition’, a
                practical direction to unite intelligence towards building
                applications for quantum technologies.
              </div>
              <div className="w-full hidden xl:block z-10  px-3">
                <HomeBoxHover items={homepagebox} />
              </div>
            </div>
            <img
              src={global}
              className="w-full max-w-[32.75rem] h-auto object-contain"
            ></img>
          </div>
          <div className="w-full xl:hidden block z-10  ">
            <HomeBoxHover items={homepagebox} />
          </div>
          <div
            className="absolute -z-2 left-1/2 top-[60%] transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
            style={{
              background:
                "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent )",
              filter: "blur(70px)",
            }}
          ></div>
        </div> */}
        {/* <div ref={VideoRef} className="w-full">
          <VideoComponent
            image={QSleeveImage}
            video={"https://thequantum.ai/videos/Companyppt.mp4"}
          />
        </div> */}
        <Footer showpage={true} />
        {/* <ScamAlertPopup /> */}
      </div>
    </div>
  );
}
